import Box from '@mui/material/Box'
import { styled } from '@mui/system'

interface SidebarNavigationTabProps {
	readonly checked?: boolean
}

const SidebarNavigationTab = styled(Box, {
	shouldForwardProp: props => props !== 'checked',
})<SidebarNavigationTabProps>(({ theme, checked }) => ({
	padding: '0.6rem 0.5rem 0.6rem 0.8rem',
	textDecoration: 'none',
	color: theme.palette.primary.main,
	fontFamily: checked
		? 'Gilroy-SemiBold, sans-serif'
		: 'Gilroy-Medium, sans-serif',
	fontSize: '1.25rem',
	fontWeight: 500,
	transition: '0.25s',
	width: '100%',
	borderRadius: '0.5rem',
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'flex-start',
	overflow: 'hidden',
	backgroundColor: checked
		? theme.palette.ocean.dark
		: theme.palette.common.white,
	'&:hover': {
		backgroundColor: checked
			? theme.palette.ocean.main
			: theme.palette.grey[100],
	},
	wordWrap: 'unset',
	wordBreak: 'keep-all',
	whiteSpace: 'nowrap',
	flexWrap: 'nowrap',
	minWidth: 'unset',
}))

export { SidebarNavigationTab }
